<div class="chat-header">
    <button class="chat-header-btn left" [class.active]="!caller" (click)="changeScreen()">
        <mat-icon>keyboard</mat-icon>
    </button>
    <button class="chat-header-btn right" [class.active]="caller" (click)="changeScreen()">
        <mat-icon>call</mat-icon>
    </button>
</div>